import Extension from "../base/extension";

function parseOptions(node) {
  try {
    return JSON.parse(node.textContent || "{}");
  } catch {
    return null;
  }
}

class ProductPhotoswipe extends Extension {
  name = "ProductPhotoswipe";
  static autoregister = true;

  #mountedSections = new Set();

  async init() {
    // No-op unless the JSON payload exists on the page
    const payloads = document.querySelectorAll("script[data-pswp-datasource]");
    if (!payloads.length) return;

    payloads.forEach(async (payload) => {
      const sectionId = payload.getAttribute("data-section-id");
      if (!sectionId) return;
      if (this.#mountedSections.has(sectionId)) return;

      const container = document.querySelector(`#product-media-${sectionId}-full`);
      if (!container) return;

      const options = parseOptions(payload);
      if (!options?.dataSource?.length) return;

      // Single delegated click handler per container
      container.addEventListener("click", async (e) => {
        const slide = e.target.closest(".swiper-slide");
        if (!slide || !container.contains(slide)) return;

        e.preventDefault();
        if ("pswpIgnore" in slide.dataset) return;

        const idx = parseInt(slide.dataset.swiperSlideIndex, 10);
        options.index = Number.isFinite(idx) ? idx : 0;

        const PhotoSwipe = await window.Stencil.ensureVendor("photoswipe");
        console.log(this.logPrefix, "PhotoSwipe loaded");
        const pswp = new PhotoSwipe(options);
        pswp.init();
      });

      this.#mountedSections.add(sectionId);
      // console.log(this.logPrefix, `Mounted PhotoSwipe for section ${sectionId}`);
    });
  }
}

export default ProductPhotoswipe;